import React, { useState, useEffect, useContext } from "react";
import SimpleBar from 'simplebar-react';
import { useLocation, Link } from "react-router-dom";
import { CSSTransition } from 'react-transition-group';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChartPie, faFileAlt, faUsers, faUserPlus, faSignOutAlt, faTimes, faBars,
  faCheckCircle, faBalanceScale, faGavel, faHome, faDollarSign, faBan, faRedo, faFileInvoiceDollar, faInbox
} from "@fortawesome/free-solid-svg-icons";

import { Nav, Badge, Image, Button, Dropdown, Accordion, Navbar, ButtonGroup } from '@themesberg/react-bootstrap';
import { AuthContext } from "../../utils/AuthContext";
import { useNavigate } from "react-router-dom";
import { RoutesCustom } from "../../routes";
import Inkasso from "../../assets/logo.webp";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n";

import API from "../../utils/api";
import { UnreadContext } from "../../utils/UnreadContext";


export default (props = {}) => {
  const location = useLocation();
  const { pathname } = location;
  const [show, setShow] = useState(false);
  const showClass = show ? "show" : "";
  const { logout } = useContext(AuthContext);
  const onCollapse = () => setShow(!show);
  const navigate = useNavigate();
  const { unreadCounts, unreadUsers, fetchUnreadCounts } = useContext(UnreadContext);

  useEffect(() => {
    fetchUnreadCounts();
  }, []);

  const { t } = useTranslation();
  const handleLogout = () => {
    logout();            // clears token + role + user in AuthContext
    // reset user profile
    navigate("/");       // redirect to home/login
  };
  const CollapsableNavItem = ({ eventKey, title, icon, children = null }) => {
    const defaultKey = pathname.indexOf(eventKey) !== -1 ? eventKey : "";

    return (
      <Accordion as={Nav.Item} defaultActiveKey={defaultKey}>
        <Accordion.Item eventKey={eventKey}>
          <Accordion.Button as={Nav.Link} className="d-flex justify-content-between align-items-center">
            <span>
              <span className="sidebar-icon"><FontAwesomeIcon icon={icon} /></span>
              <span className="sidebar-text">{title}</span>
            </span>
          </Accordion.Button>
          <Accordion.Body className="multi-level">
            <Nav className="flex-column">
              {children}
            </Nav>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    );
  };

  const NavItem = ({ title, link, external, target, icon, image, badgeText, badgeBg = "secondary", badgeColor = "primary", onClick }) => {
    const classNames = badgeText ? "d-flex justify-content-start align-items-center justify-content-start" : "";
    const navItemClassName = link === pathname ? "active" : "";
    const [unreadUsers, setUnreadUsers] = useState({});
    // Action-only item (like logout)
    if (!link) {
      return (
        <Nav.Item className={navItemClassName} onClick={() => setShow(false)}>
          <Button variant="link" className={classNames + " text-start w-100 text-white ps-3"} onClick={onClick}>
            {icon && <span className="sidebar-icon me-3"><FontAwesomeIcon icon={icon} /></span>}
            <span className="sidebar-text ">{title}</span>
          </Button>
        </Nav.Item>
      );
    }

    // Normal nav link
    return (
      <Nav.Item className={navItemClassName} onClick={() => setShow(false)}>
        <Nav.Link as={link ? Link : "a"} to={link} href={external ? link : undefined} target={target} className={classNames} onClick={onClick}>
          {icon && <span className="sidebar-icon  me-2"><FontAwesomeIcon icon={icon} /></span>}
          {image && <Image src={image} width={20} height={20} className="sidebar-icon svg-icon" />}
          <span className="sidebar-text">{title}</span>
          {badgeText && (
            <Badge pill bg={badgeBg} text={badgeColor} className="badge-md notification-count ms-2">{badgeText}</Badge>
          )}
        </Nav.Link>
      </Nav.Item>
    );
  };


  return (
    <>
      {/* Mobile Navbar */}
      <Navbar expand={false} collapseOnSelect variant="dark" className="navbar-theme-primary px-4 d-md-none">
        <Navbar.Brand as={Link} to={RoutesCustom.AdminDashboardOverview.url}>
          <Image
            src={Inkasso}
            alt="Inkasso log"
            style={{ height: "50px", filter: "brightness(0) invert(0)" }}
            className="navbar-brand-light"
          />
        </Navbar.Brand>
        <Navbar.Toggle as={Button} aria-controls="main-navbar" onClick={onCollapse}>
          <span className="navbar-toggler-icon" />
        </Navbar.Toggle>
      </Navbar>

      {/* Sidebar */}
      <CSSTransition timeout={300} in={show} classNames="sidebar-transition">
        <SimpleBar
          className={`collapse ${showClass} sidebar d-md-block bg-primary text-white h-100
            ${props.isSidebarOpen ? "desktop-open" : "desktop-collapsed"}`}
        >
          <div
            className="sidebar-inner pt-3 d-flex flex-column h-100"
            style={{
              paddingLeft: props.isSidebarOpen ? "0.7rem" : "0.7rem",
              paddingRight: props.isSidebarOpen ? "1rem" : "1.5rem"
            }}
          >
            {/* Sidebar toggle button */}
            <div className="d-none d-md-flex mb-3" style={{ justifyContent: props.isSidebarOpen ? "flex-end" : "center" }}>
              <Button variant="link" className="text-white p-1" onClick={() => props.setIsSidebarOpen(!props.isSidebarOpen)}>
                <FontAwesomeIcon icon={faBars} />
              </Button>
            </div>

            {/* Mobile User Card */}
            <div className="user-card d-flex d-md-none align-items-center justify-content-between justify-content-md-center pb-4">
              <div className="d-flex align-items-center">
                <div className="user-avatar lg-avatar me-4"></div>
              </div>
              <Nav.Link className="collapse-close d-md-none" onClick={onCollapse}>
                <FontAwesomeIcon icon={faTimes} />
              </Nav.Link>
            </div>

            {/* Main nav links */}
            <Nav className="flex-column pt-3 pt-md-0">
              {/* Logo */}
              <div className="sidebar-logo">
                {/* Desktop */}
                <div className="d-none d-md-flex justify-content-center">
                  {props.isSidebarOpen ? (
                    <Image
                      src={Inkasso}
                      alt="Inkasso log"
                      style={{ marginBottom: "20px", filter: "brightness(0) invert(0)" }}
                      className="navbar-brand-light"
                    />
                  ) : (
                    <span
                      style={{
                        fontSize: "1.5rem",
                        fontWeight: "bold",
                        color: "black",
                        display: "inline-block",
                        width: "50px",
                        height: "50px",
                        lineHeight: "50px",
                        textAlign: "center",
                        borderRadius: "8px",
                        marginRight: "10px"
                      }}
                    >
                      N
                    </span>
                  )}
                </div>

                {/* Mobile */}
                <div className="d-flex d-md-none justify-content-start">
                  <Image
                    src={Inkasso}
                    alt="Inkasso log"
                    style={{ height: "50px", marginBottom: "10px", filter: "brightness(0) invert(0)" }}
                    className="navbar-brand-light"
                  />
                </div>
              </div>

              {/* Nav Items */}
              <NavItem title={t("sidebar.overview")} link={RoutesCustom.AdminDashboardOverview.url} icon={faChartPie} />
              <NavItem title={t("sidebar.allClaims")} link={RoutesCustom.ClaimsAdmin.url} icon={faFileAlt} />
               <NavItem
                title={t("sidebar.messages")}
                link={RoutesCustom.Messages2.url}
                icon={faInbox}
                badgeText={unreadUsers > 0 ? unreadUsers : null}
                badgeBg="danger"
                badgeColor="white"
              />
              <NavItem title={t("sidebar.allClients")} link={RoutesCustom.Clients.url} icon={faUsers} />
              <NavItem title={t("sidebar.registerNewUsers")} link={RoutesCustom.AdminSignup.url} icon={faUserPlus} />
              <NavItem title={t("sidebar.debtCollection")} link={RoutesCustom.DebtCollection.url} icon={faFileInvoiceDollar} />
              <NavItem title={t("sidebar.resubmissions")} link={RoutesCustom.Resubmissions.url} icon={faRedo} />
              <NavItem title={t("sidebar.installmentPayment")} link={RoutesCustom.Installmentpayment.url} icon={faDollarSign} />
              <NavItem title={t("sidebar.courtProcedure")} link={RoutesCustom.CourtDunningProcedure.url} icon={faBalanceScale} />
              <NavItem title={t("sidebar.foreclosures")} link={RoutesCustom.Foreclosures.url} icon={faHome} />
              <NavItem title={t("sidebar.paid")} link={RoutesCustom.Paid.url} icon={faDollarSign} />
             

              <NavItem title={t("sidebar.completed")} link={RoutesCustom.Completed.url} icon={faCheckCircle} />
              <NavItem title={t("sidebar.cancellation")} link={RoutesCustom.Cancellation.url} icon={faBan} />
              <NavItem title={t("feedback")} link={RoutesCustom.FeedbackAdmin.url} icon={faCheckCircle} />
            </Nav>

            {/* Logout at bottom */}
            <div className="mt-auto">


              <Dropdown.Divider className="my-3 border-indigo" />
              <Nav className="flex-column">
                <NavItem title="Logout" onClick={handleLogout} icon={faSignOutAlt} />
              </Nav>
            </div>
          </div>
        </SimpleBar>
      </CSSTransition>
    </>
  );
};
